require('./html-post.component');
require('./html-post-view.component');
require('./html-post-edit.component');
require('./html-post.service');
